<template>
	<div class="product-pricing pb-8">
    <table class="w-full md:w-4/5">
      <thead>
        <tr class="bg-smoke">
          <th>Quantity</th>
          <th>EXW</th>
          <th>FOB</th>
          <th>Lead Time</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(price, index) in pricing"
          :key="`price-${index}`"
        >
          <td class="py-2 px-2 md:px-6 border">
            {{
              index === 0
                ? `1 - ${price.maxQuantity}`
                : `${parseInt(pricing[index - 1].maxQuantity.replace(/,/g, ''))+1} - ${price.maxQuantity}`
              }}
          </td>
          <td class="py-4 px-2 md:px-6 border">
            {{ price.displayExwPrice }}
          </td>
          <td class="py-4 px-2 md:px-6 border">
            {{ price.displayFobPrice }}
          </td>
          <td class="py-4 px-2 md:px-6 border">
            {{ price.leadTimeInDays }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
export default {
	name: 'ProductPricing',
	props: {
		pricing: {
			required: true
		}
	}
}
</script>
<style lang="scss" scoped>
  .product-pricing {
    table {
      th {
        @apply w-1/4 border py-2 font-normal;
      }
    }
  }
</style>